jQuery(document).ready(function ($) {
  $(".js-pt-video-modal-toggle").on("click", function (e) {
    e.preventDefault();

    var modalId = $(this).attr("data-modal-id");
    var videoCode = $(this).attr("data-video-code");

    const embedUrl = "https://player.vimeo.com/video/";
    const videoUrl =
      embedUrl + videoCode + "?&title=1&description=0&autoplay=1&muted=0";

    const width = "100%";
    const height = "100%";

    const iframe = $("<iframe>", {
      src: videoUrl,
      width: width,
      height: height,
      frameborder: 0,
      allowfullscreen: true,
      webkitallowfullscreen: true,
      mozallowfullscreen: true,
      id: "vimeo_video",
      allow: "autoplay; fullscreen",
      "data-video-code": videoCode,
    });

    $(this)
      .closest("body")
      .find(".c-modal__container--vimeo-video--pt")
      .attr("data-video-code", videoCode)
      .attr("id", videoCode);

    // console.log("#" + videoCode + ".c-modal__container");
    $("#" + videoCode + ".c-modal__container")
      .find(".c-modal__inner")
      .append(iframe);

    var modal = $("#" + videoCode);

    // toggle modal & overlay
    modal.removeClass("is-closed", "out");
    modal.children().removeClass("is-closed", "out");
  });

  function modalOverlayClose() {
    $(".c-modal-overlay--vimeo-video--pt").on("click", function (e) {
      $(this).parent().find(".c-modal__inner").empty();
      $(this).parent().addClass("is-closed", "out");
      $(this).parent().siblings().addClass("is-closed", "out");
      //reset ids
      $(this).parent().attr("data-video-code", "").attr("id", "");
    });
  }
  modalOverlayClose();

  $(".c-modal__close--vimeo-video-pt").on("click", function (e) {
    $(this)
      .parent()
      .parent()
      .addClass("is-closed", "out")
      .attr("data-video-code", "")
      .attr("id", "");

    $(this).parent().addClass("is-closed", "out");
    $(this).parent().find(".c-modal__inner").empty();
  });
});
